import React from "react";
import TeamCard from "./TeamCard";

/**
 *
 * @param {Object} props
 * @param {Array.<{imageUrl: String, name: String, role: String}>}
 */
const TeamList = ({ list }) => {
  return (
    <div className="team-container flex items-center justify-center team-list">
      {list.map((team, index) => {
        return (
          <TeamCard
            key={index}
            image={team.imageUrl}
            name={team.name}
            role={team.role}
          />
        );
      })}
    </div>
  );
};

export default TeamList;
